<template>
  <ul v-if="totalPages > 1" class="submission-items__pagination">
    <li><button
      v-if="currentPage !== 1"
      class="submission-items__pagination-link submission-items__pagination-link-prev button button--plain button--small"
      @click="prevPage"
    >
      <span class="submission-items__pagination-link-chevron"></span>
      Previous
    </button></li>
    
    <!-- <p class="submissions-items__pagination-current">Page {{ currentPage }} of {{ totalPages }}</p> -->

    <li v-for="page in totalPages" :key="page">
      <button
        class="submission-items__pagination-pagelink"
        :class="{ 'submission-items__pagination-pagelink--active': page === currentPage }"
        @click="changePage(page)"
      >
        {{ page }}
      </button>
    </li>

    <li><button
      v-if="currentPage !== totalPages"
      class="submission-items__pagination-link submission-items__pagination-link-next button button--plain button--small"
      @click="nextPage"
    >
      Next
      <span class="submission-items__pagination-link-chevron"></span>
    </button></li>
  </ul>
</template>

<script>
import { mapFields } from "vuex-map-fields";
export default {
  props: {},
  created() {},
  components: {},
  mounted() {
    let params = new URLSearchParams(window.location.search);
    if(params.get('page')){
      this.currentPage = parseInt(params.get('page'));
    }
  },
  computed: {
    ...mapFields([
      "filteredSubmissions", 
      "submissions.totalPages", 
      "submissions.currentPage"
    ]),
  },
  methods: {
    changePage(page) {
      this.currentPage = page;
      this.updateURL(page);
      // scroll to top of page
      window.scrollTo(0, 0);
    },
    nextPage() {
      this.currentPage++;
      this.updateURL(this.currentPage);
      // scroll to top of page
      window.scrollTo(0, 0);
    },
    prevPage() {
      this.currentPage--;
      this.updateURL(this.currentPage);
      // scroll to top of page
      window.scrollTo(0, 0);
    },
    updateURL(page) {
      // add or update the page ref in URL
      const paramsString = window.location.search;
      const newParams = new URLSearchParams(paramsString);
      newParams.set('page', page);      
      var newUrl = window.location.origin 
            + window.location.pathname 
            + '?' + newParams.toString();
      window.history.pushState({path:newUrl},'',newUrl);
    }
  },
};
</script>

<style lang="scss"></style>
